import React from 'react';
import cn from 'classnames';

import Text, { TextContent } from '@lightspeed/cirrus-text';

const baseClass = 'retail-page-listing';

export const PageListing = ({ children }) => <div className={baseClass}>{children}</div>;

export const PageListingRow = ({ children }) => (
  <div className={`${baseClass}__row`}>{children}</div>
);

export const PageListingDivider = () => <div className={`${baseClass}__divider`} />;

export const PageListingItem = ({ children }) => (
  <div className={`${baseClass}__item`}>{children}</div>
);

export const PageListingDescriptionItem = ({ mainText, secondaryText, children }) => {
  const classNames = cn(`${baseClass}__item`, `${baseClass}__item--description`);

  return (
    <div className={classNames}>
      <TextContent className={`${baseClass}__item__content`}>
        <Text heading4 element="div">
          <div className={`${baseClass}__item__heading`}>{mainText}</div>
        </Text>
        <Text bodySmall dimmed>
          {secondaryText}
        </Text>
      </TextContent>
      {children ? <div className="extra">{children}</div> : null}
    </div>
  );
};
